import Title from '../shared/Title'
import Button from '../shared/Button'

const Events = () => {
  const events = [
    {
      date: "20/03/2025",
      title: "Journée du Pharmacien: IA & Officine",
      location: "Montpellier",
      description: "A day of exchange and inspiration around the impact of artificial intelligence on pharmacy.",
      image: "https://picsum.photos/seed/rays-event1/800/400"
    },
    {
      date: "13/03/2025",
      title: "Annual Alumni Meet 2025",
      location: "Rajagiri Campus",
      description: "Join us for a day of reconnecting, networking and celebrating the Rajagiri spirit.",
      image: "https://picsum.photos/seed/rays-event2/800/400"
    }
  ]

  return (
    <section className="events">
      <div className="container">
        <div className="events__header">
          <span className="events__tag">STAY CONNECTED</span>
          <h2 className="events__title">UPCOMING EVENTS</h2>
          <p className="events__subtitle">Join us for these exciting gatherings</p>
        </div>

        <div className="events__grid">
          {events.map((event, index) => (
            <div key={index} className="event-card">
              <div className="event-card__image">
                <img src={event.image} alt={event.title} />
                <div className="event-card__date">{event.date}</div>
              </div>
              <div className="event-card__content">
                <h3>{event.title}</h3>
                <p className="event-card__location">{event.location}</p>
                <p className="event-card__description">{event.description}</p>
                <button className="event-card__button">Learn More</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Events 